export function isValidWeTransferLink(link) {
  const url = URL.canParse(link) ? new URL(link) : null;
  if (url && url.protocol === 'https:') {
      if (url.href.startsWith('https://we.tl/t-')) return true;
      if (
        (url.host === 'wetransfer.com' || url.host.endsWith('.wetransfer.com')) &&
        url.pathname.startsWith('/downloads/')
      ) return true;
  }
  return false;
}

// Check whether the given user can upload scans via the provided sourceUrl on S3
export function isValidS3Link(user, sourceUrl) {
  return (sourceUrl && user?.uploadPaths?.some(path => sourceUrl.startsWith(path)));
}

export function isValidS3BucketLink(user, sourceUrl) {
  return (sourceUrl && user?.uploadPaths?.some(path => {
    if (sourceUrl.startsWith(path)) {
      let parts = sourceUrl.split('/');
      if (parts.length == 3 || (parts.length == 4 && parts[3] === '')) {
        return true;
      }
    } else {
      return false;
    }
  }))
}

export function isValidS3PathLink(user, sourceUrl) {
  return (sourceUrl && user?.uploadPaths?.some(path => {
    if (sourceUrl.startsWith(path)) {
      let parts = sourceUrl.split('/');
      if (parts.length >= 4 && parts[3] !== '') {
        return true;
      }
    } else {
      return false;
    }
  }))
}
